import React from 'react';
import { Upload, Play, RotateCcw } from 'lucide-react';

const VideoUploadSection = ({
  getRootProps,
  getInputProps,
  isDragActive,
  videoPreview,
  selectedElement,
  setSelectedElement,
  elements,
  handleAnalyze,
  resetUpload,
  uploadStatus
}) => {
  return (
    <div className="upload-section">
      <div
        {...getRootProps()}
        className={`dropzone ${isDragActive ? 'dragactive' : ''} ${videoPreview ? 'has-file' : ''}`}
      >
        <input {...getInputProps()} />
        {videoPreview ? (
          <div className="video-preview">
            <video
              src={videoPreview.previewUrl}
              controls
              className="preview-video"
              style={{ maxWidth: '300px', maxHeight: '200px' }}
            />
            <p className="file-name">{videoPreview.file.name}</p>
            <p className="file-size">
              {(videoPreview.file.size / (1024 * 1024)).toFixed(2)} MB
              {videoPreview.duration != null && (
                <> &mdash; {Math.floor(videoPreview.duration / 60)}:{String(Math.floor(videoPreview.duration % 60)).padStart(2, '0')}</>
              )}
            </p>
            {uploadStatus === 'too_long' && (
              <p style={{ color: '#ef4444', fontSize: '13px', marginTop: '4px' }}>
                Video exceeds 20-second limit — please trim before uploading
              </p>
            )}
          </div>
        ) : (
          <div className="drop-content">
            <div className="upload-icon-wrapper">
              <Upload className="upload-icon" />
            </div>
            <p className="drop-title">
              {isDragActive ? 'Drop your video here' : 'Drag & drop your video here'}
            </p>
            <p className="drop-hint">
              {isDragActive ? '' : 'or click to upload \u2014 MP4, MOV, AVI, WebM (max 10 seconds Jumps, 20 seconds Spins/Footwork)'}
            </p>
          </div>
        )}
      </div>

      {videoPreview && (
        <div className="element-selector">
          <label className="block text-sm font-medium mb-2">
            Select Skating Element:
          </label>
          <select
            value={selectedElement}
            onChange={(e) => setSelectedElement(e.target.value)}
            className="element-select"
          >
            <option value="">Choose element type...</option>
            {elements.map((element) => (
              <option key={element.value} value={element.value}>
                {element.label}
              </option>
            ))}
          </select>
        </div>
      )}

      {videoPreview && selectedElement && (
        <div className="action-buttons">
          <button
            onClick={handleAnalyze}
            className="analyze-button"
            disabled={uploadStatus === 'uploading' || uploadStatus === 'processing' || uploadStatus === 'too_long'}
          >
            <Play className="w-4 h-4 mr-2" />
            Analyze Video
          </button>
          <button onClick={resetUpload} className="reset-button">
            <RotateCcw className="w-4 h-4 mr-2" />
            Reset
          </button>
        </div>
      )}
    </div>
  );
};

export default VideoUploadSection;
